import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TeamNode } from 'src/app/shared/models/type-list';
import { TeamService } from 'src/app/team-edit/services/team.service';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'update-standardwork-dialog',
    templateUrl: './update-standardwork-dialog.component.html',
    styleUrls: ['./update-standardwork-dialog.component.scss'],
    imports: [NgIf, MatDialogTitle, MatButton, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, MatProgressSpinner]
})
export class UpdateStandardWorkDialog implements OnInit {
  
  plantName: string = '';
  teamID: number = 0;
  versionID: string = '0';

  isComparing: boolean = false;
  isUpdating: boolean = false;
  isComplete: boolean = false;
  noChange: boolean = false;

  pitchVariantList: any;

  displayedColumns: string[] = ["pitch_id","subassembly_id","pitch_name","variant_name"]


  constructor(
    public dialogRef: MatDialogRef<UpdateStandardWorkDialog>,
    @Inject(MAT_DIALOG_DATA) public inData: TeamNode,
    private teamService: TeamService
  ) 
  { 
    console.log(inData)
  }

  ngOnInit(): void {
    this.plantName = this.inData.plant_name? this.inData.plant_name: '';
    this.teamID = this.inData.team_id? this.inData.team_id: 0;
    this.versionID = this.inData.version_id? this.inData.version_id: '0';

    this.compareWithStandardizedWork();
  }

  onNoClick(): void {
    const confirmResponse = {
      response: false  
    }
    console.log(confirmResponse)
    this.dialogRef.close(confirmResponse)
  }
  
  onSubmit(): void {
    console.log('Submit job to update Standardized Work')
    this.isUpdating = true;
    let pitchVariants: any[] = [];
    this.pitchVariantList?.forEach((variant: any) => {
      const pitchVariant = {
        "pitch_config_id": variant.pitch_config_id,
        "variant_id": variant.variant_id
      };
      pitchVariants.push(pitchVariant);
    });
    this.teamService.updateStandardizedWork(this.plantName, this.teamID, this.versionID, pitchVariants).subscribe(out=>{
      this.isUpdating = false;
      this.isComplete = true;
      setTimeout(() =>{
        this.dialogRef.close()
      }, 1000);

    })
    
  }

  compareWithStandardizedWork(){
    this.isComparing = true;
    this.teamService.compareStandardizedWork(this.plantName, this.teamID, this.versionID).subscribe(out=>{
      this.pitchVariantList = out.Body;
      console.log(out.Body)
      this.isComparing = false;
      if (this.pitchVariantList.length == 0){ this.noChange = true }
    })
  }
}
